module.exports = __webpack_public_path__ + "static/media/45.3a1c34aa.png";